
import React from 'react';
import style from './AccountSettings.module.css';
import {
	buildTestData,
} from 'Vulture/TestData.js';

const DurationPicker = ({
	value = 5,
	readOnly = false,
	onChange = () => {},
	min = 1,
	max = 3600,
	step = 1,
}) => {
	const handleIncrement = () => {
		const newValue = Math.min(max, value + step);
		onChange(newValue);
	};

	const handleDecrement = () => {
		const newValue = Math.max(min, value - step);
		onChange(newValue);
	};

	const handleChange = (e) => {
		const newValue = parseInt(e.target.value, 10);
		if (!isNaN(newValue) && newValue >= min && newValue <= max) {
			onChange(newValue);
		}
	};

	return (
		<div className={`${style.numberPicker}`}>
			{!readOnly && (
				<button
					type="button"
					className={`${style.durationButton} button`}
					onClick={handleDecrement}
				>
					-
				</button>
			)}
			<input
				value={value}
				type="number"
				min={min}
				max={max}
				step={step}
				className={style.durationInput}
				data-testing-info={buildTestData('input--duration')}
				readOnly={readOnly}
				onChange={handleChange}
				style={{
					border:          readOnly ? 'none' : undefined,
					outline:         readOnly ? 'none' : undefined,
					backgroundColor: readOnly ? 'transparent' : undefined,
				}}
			/>
			{!readOnly && (
				<button
					type="button"
					className={`${style.durationButton} button`}
					onClick={handleIncrement}
				>
					+
				</button>
			)}
		</div>
	);
};

export default DurationPicker;
